'use client';

import dynamic from 'next/dynamic';
import { useHasWPSession } from './hooks';

export type WPAdminFeaturesProps = {
  id: string;
  name?: string;
};

const WPAdminFeaturesLazy = dynamic(
  () => import('./WPAdminFeaturesClient').then(mod => ({ default: mod.WPAdminFeaturesClient })),
  { ssr: false },
);

export function WPAdminFeatures(props: WPAdminFeaturesProps) {
  const { hasWPSession } = useHasWPSession();

  if (!hasWPSession) {
    return null;
  }

  return <WPAdminFeaturesLazy {...props} />;
}
